const news = (state = null, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'INITIAL_DATA':
      return payload.news || [];

    case 'SET_ARTICLES':
      return payload;

    case 'ADD_ARTICLE':
      return [payload, ...state];

    case 'REMOVE_ARTICLE':
      return state.filter((x) => x._id !== payload);

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

export default news;
